import { PaymentPlanId } from '../models/order.model';
import { PaymentPlansResponse } from '../../checkout/checkout-model';

export const PAY_LATER_PLAN_IDS: readonly PaymentPlanId[] = [PaymentPlanId.ONE_MONTH];

export const PAYMENT_PLAN_DISPLAY_ORDER: readonly PaymentPlanId[] = [
  PaymentPlanId.THREE_MONTHS,
  PaymentPlanId.TWO_MONTHS,
  PaymentPlanId.ONE_MONTH_PAY_NOW,
  PaymentPlanId.ONE_MONTH,
];

export const PAYMENT_PLAN_LABEL_KEYS: Partial<Record<PaymentPlanId, string>> = {
  [PaymentPlanId.THREE_MONTHS]: 'CHECKOUT.PAY_IN_4',
  [PaymentPlanId.TWO_MONTHS]: 'CHECKOUT.PAY_IN_3',
  [PaymentPlanId.ONE_MONTH_PAY_NOW]: 'CHECKOUT.PAY_IN_2',
  [PaymentPlanId.ONE_MONTH]: 'CHECKOUT.PAY_LATER',
};

export function isPayLaterPlan(planId: PaymentPlanId | null | undefined): boolean {
  return !!planId && PAY_LATER_PLAN_IDS.includes(planId);
}

export function sortPaymentPlans(plans: PaymentPlansResponse[]): PaymentPlansResponse[] {
  const rank = (id: PaymentPlanId) => {
    const index = PAYMENT_PLAN_DISPLAY_ORDER.indexOf(id);

    return index === -1 ? PAYMENT_PLAN_DISPLAY_ORDER.length : index;
  };

  return [...plans].sort((a, b) => rank(a.id) - rank(b.id));
}

export function getDefaultPaymentPlanId(plans: PaymentPlansResponse[]): PaymentPlanId | null {
  const payNowPlans = plans.filter((plan) => !isPayLaterPlan(plan.id));

  return (
    payNowPlans.find((plan) => !plan.disabledReason)?.id ??
    payNowPlans[0]?.id ??
    plans[0]?.id ??
    null
  );
}

export function getDueTodayAmount(plan: PaymentPlansResponse | null | undefined): number {
  return plan?.installment?.find((installment) => installment.nbOfInstallment === 0)?.amount ?? 0;
}
